import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../../Layout/Topo';
import Overlay from '../../Miscelania/Overlay';

import Select from 'react-select';
import InputMask from 'react-input-mask';
import FlightReportApprovalsCheckbox from '../Elements/FlightReportApprovalsCheckbox';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class FlightReportApprovals extends Component {

  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      flight_report_status_select: [],
      bases_select: [],
      checkbox_marked_ids: [],
      checkbox_marked_data: [],
      checkbox_changed: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.approve = this.approve.bind(this);
    this.approvePlus = this.approvePlus.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.checkbox = this.checkbox.bind(this);
    this.markedCheckboxId = this.markedCheckboxId.bind(this);
    this.UnmarkCheckboxId = this.UnmarkCheckboxId.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            flight_report_status_select: responseJson.data.flight_report_status_select,
            bases_select: responseJson.data.bases_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      base_id: this.state.base_id,
      flight_report_status: this.state.status,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/aprovacoes/pendentes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data, headers: responseJson.data.headers, searched: 1});
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshTable(event) {
    var datasave = {
      base_id: this.state.base_id,
      flight_report_status: this.state.status,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios/voo/aprovacoes/pendentes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data, headers: responseJson.data.headers, searched: 1});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button onClick={() => {this.approve(cell)}} className="btn btn-success btn-sm"><i className="fa fa-check"></i></button>
      </div>
    );

    return botao;
  }

  approve(flight_report_approval_id) {
    var self = this;
    if(window.confirm(this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.aprovar)) {
      this.handleAlert('', '', 'open');
      var datasave = {
        flight_report_approval_id: flight_report_approval_id,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(flight_report_approval_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  approvePlus() {
    var self = this;
    if(window.confirm(this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.aprovar)) {
      this.handleAlert('', '', 'open');
      var datasave = {
        flight_report_approval_ids: this.state.checkbox_marked_ids,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshTable(responseJson);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(flight_report_approval_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == flight_report_approval_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  checkbox (cell, row) {
    var botao = (
      <div>
        <FlightReportApprovalsCheckbox handleAlert={this.handleAlert} markedCheckboxId={this.markedCheckboxId} UnmarkCheckboxId={this.UnmarkCheckboxId} checkbox_marked_ids={this.state.checkbox_marked_ids} id={cell} data={row} />
      </div>
    );

    return botao;
  }

  markedCheckboxId (value) {
    var ids_temp = this.state.checkbox_marked_ids;
    var data_temp = this.state.checkbox_marked_data;
    ids_temp.push(value.id);
    data_temp.push(value);
    this.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  UnmarkCheckboxId (value) {
    var self = this;
    var ids_temp = [];
    var data_temp = [];
    var checkbox_ids = this.state.checkbox_marked_ids;
    checkbox_ids.map(function(checked_id) {
      if(checked_id !== value.id) {
        ids_temp.push(checked_id);
        data_temp.push(value);
      }
    });
    self.setState({checkbox_marked_ids: ids_temp, checkbox_marked_data: data_temp});
  }

  render() {
    var self = this;
    var columns = null

    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.titulo}</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.formulario.Base}:</label>
            <Select
              className=""
              name="base_id"
              value={this.state.base_id}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'base_id')}
              options={this.state.bases_select}
              required
            />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.formulario.TipoDeAprovacao}:</label>
            <Select
              className=""
              name="status"
              value={this.state.status}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'status')}
              options={this.state.flight_report_status_select}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.general.pesquisar}</button>
      </form>
      <hr/>
      <div className="row">
        <div className="col-md-12">
          <button onClick={() => {this.approvePlus()}} className="btn btn-success btn-block btn-lg"><i className="fa fa-fw fa-plus"></i> {this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.botaoAprovar}</button>
        </div>
      </div>
      {self.state.searched === 1 &&
          <div>
            <hr/>
            <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>
              <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.checkbox} width='30'>
              </TableHeaderColumn>
              <TableHeaderColumn dataField={'id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>#</TableHeaderColumn>
              <TableHeaderColumn dataField={'date'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.Data}</TableHeaderColumn>
              <TableHeaderColumn dataField={'base'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.Base}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.Aeronave}</TableHeaderColumn>
              <TableHeaderColumn dataField={'aircraft_model'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.Frota}</TableHeaderColumn>
              <TableHeaderColumn dataField={'contract'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.Contrato}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_type'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.TipoDeVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_number'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.NumeroDoVoo}</TableHeaderColumn>
              <TableHeaderColumn dataField={'flight_report_status'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='260'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.Status}</TableHeaderColumn>
              <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.RelatoriosDeVoo.RelatoriosPendentesDeAprovacao.tabela.Acoes}</TableHeaderColumn>
            </BootstrapTable>
          </div>
      }
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportApprovals;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Control/FlightReportApprovals.js